import StyledButton from "components/shared/StyledButton";
import TextButton from "components/shared/TextButton";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import type { IDeclaration } from "store/contributionStore";
import { generateDeclaration } from "store/contributionStore";
import { useAppDispatch } from "store/store";

import variables from "../../../assets/styles/_variables.module.scss";
import styles from "../style.module.scss";
import type { DeclarationsCardsData } from "../utils";

interface IDASConfirmModal {
    isCompanyInfoComplete: boolean;
    setModalType: Dispatch<SetStateAction<string>>;
    declarationData: IDeclaration | DeclarationsCardsData | undefined;
    handleClose: () => void;
}

/**
 * Within DeclarationPage, modal to confirm download of DAS2 file.
 */
const DASDownloadModal = ({ isCompanyInfoComplete, setModalType, declarationData, handleClose }: IDASConfirmModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const handleDAS2Download = async () => {
        if (declarationData) {
            const response = await dispatch(generateDeclaration({ declaration: declarationData }));
            if (response.meta.requestStatus === "fulfilled") {
                handleClose();
            }
        }
    };

    return (
        <div className={styles["das-confirm-modal"]}>
            <span className={styles["das-description"]}>
                {t("Declarations.DAS2.DownloadFileDescription", {
                    yearN: declarationData?.year,
                    yearN1: (declarationData?.year ?? new Date().getFullYear()) - 1,
                })}
            </span>
            {!isCompanyInfoComplete && (
                <div className={styles["company-error"]}>
                    <p>
                        {t("Payment.FulfilCompanyInfoFirst")}{" "}
                        <TextButton
                            text={t("Declarations.DAS2.CompleteInfo")}
                            handleClick={() => setModalType("updateCompany")}
                            style={{ color: variables["danger"], fontSize: "0.8rem" }}
                        />
                    </p>
                </div>
            )}
            <StyledButton
                buttonType="primary"
                onClick={handleDAS2Download}
                style={{ width: "100%" }}
                disabled={!isCompanyInfoComplete}
            >
                {t("Declarations.DAS2.DownloadFile")}
            </StyledButton>
        </div>
    );
};

export default DASDownloadModal;
